<template>
  <div class="autocomplete">
    <vs-input
      :size="size"
      :class="customClass"
      :name="name"
      :id="id"
      v-model="content"
      v-on="listeners"
      @blur="handleClickOutside"
      autocomplete="off"
    />

    <ul id="autocomplete-results" v-show="isOpen" class="autocomplete-results">
      <li
        v-for="(result, i) in results"
        :key="i"
        @click="setResult(result)"
        class="autocomplete-result"
      >
        {{ result }}
      </li>
    </ul>
  </div>
</template>

<script>
import services from '../../services';

export default {
  props: {
    value: {
      default: '',
      type: [String, Number],
    },
    size: {
      default: 'normal',
      type: String,
    },
    customClass: {
      default: '',
      type: String,
    },
    name: {
      default: '',
      type: String,
    },
    id: {
      default: '',
      type: String,
    },
    configAutoComplete: {
      default: null,
      type: Object,
    },
    minimumCharacters: {
      default: 4,
      type: Number,
    },
  },
  data() {
    return {
      content: this.value,
      originalFind: null,
      isOpen: false,
      baseResults: [],
      results: [],
      debounceTask: null,
    };
  },
  computed: {
    listeners() {
      return {
        ...this.$listeners,
        input: (value) => {
          this.find();
          this.$emit('input', value);
        },
      };
    },
  },
  methods: {
    find() {
      if (this.debounceTask) {
        clearTimeout(this.debounceTask);
      }

      if (!this.content || this.content.length < this.minimumCharacters) {
        this.isOpen = false;
        this.results = [];
        this.baseResults = [];
        return;
      }

      this.debounceTask = setTimeout(() => {
        this.getData();
      }, 1000);
    },
    getData() {
      const { model, field } = this.configAutoComplete;
      const action = `/${model}/${field}?q=${this.content}`;

      if (this.baseResults.length) {
        return this.filterResults();
      }

      services.getAll('autocomplete', null, action).then((res) => {
        this.baseResults = [];
        this.results = [];
        this.originalFind = this.content;

        res.data.forEach((element) => {
          this.results.push(element[field]);
          this.baseResults.push(element[field]);
        });

        this.isOpen = res.data.length >= 1;
      });
    },
    filterResults() {
      this.results = this.baseResults.filter(
        (x) =>
          this.replaceSpecialChars(x.toUpperCase()).indexOf(
            this.replaceSpecialChars(this.content.toUpperCase()),
          ) >= 0,
      );

      const forceFind = this.content.indexOf(this.originalFind) == -1;

      if (!this.results.length || forceFind) {
        this.baseResults = [];
        return this.getData();
      }

      this.isOpen = true;
    },
    setResult(value) {
      this.content = value;
      this.$emit('input', value);
      this.isOpen = false;
    },
    handleClickOutside() {
      setTimeout(() => {
        this.isOpen = false;
      }, 250);
    },
    replaceSpecialChars(str) {
      return str
        .replace(/[ÀÁÂÃÄÅ]/, 'A')
        .replace(/[àáâãäå]/, 'a')
        .replace(/[ÈÉÊË]/, 'E')
        .replace(/[Ç]/, 'C')
        .replace(/[ç]/, 'c');
    },
  },
  watch: {
    value(value) {
      this.content = value;
    },
  },
};
</script>

<style lang="scss" scoped>
.autocomplete {
  position: relative;
}

.autocomplete-results {
  z-index: 1000;
  position: absolute;
  padding: 0;
  margin: 0;
  border: 1px solid rgb(186, 206, 228);
  border-radius: 4px;
  overflow: auto;
  width: 100%;
  max-height: 212px;
  background-color: white;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px white;
    border-radius: 10px;
  }

  &::-webkit-scrollbar-thumb {
    background: #a6a6a6;
    border-radius: 4px;
  }
}

.autocomplete-result {
  list-style: none;
  text-align: left;
  padding: 4px 2px;
  cursor: pointer;
  background-color: white;
  font-size: 14px;
  padding: 16px;
}

.autocomplete-result:hover {
  background-color: #f8f8f8;
}
</style>
